import type { FilterFieldDef } from './types'
import type { WarehousePositionLotType } from '@/lib/api/warehouse-position-api'
import { PositionPicker } from '@/components/warehouse-positions/position-picker'

interface PositionFilterOptions {
    label: () => string
    /** Loại lô của kho đang xem — quyết định danh sách vị trí được chọn. */
    lotType: WarehousePositionLotType
    placeholder?: () => string
}

/**
 * Bộ lọc theo vị trí lưu kho. Cùng khuôn với `growerFilter` / `productFilter`:
 * giá trị là id, rỗng nghĩa là "tất cả", chip do màn tự tra tên.
 */
export function positionFilter({
    label,
    lotType,
    placeholder,
}: PositionFilterOptions): FilterFieldDef<string> {
    return {
        defaultValue: '',
        label,
        parse: (raw) => (typeof raw === 'string' && raw ? raw : undefined),
        chipLabel: () => undefined,
        render: ({ id, value, onChange }) => (
            <PositionPicker
                id={id}
                lotType={lotType}
                value={value || undefined}
                onChange={(positionId) => onChange(positionId)}
                placeholder={placeholder?.()}
                allowClear
            />
        ),
    }
}
